import {
  AnecdotesFooterComponent,
  SuccessAnimationComponent,
  TextComponent,
  StepperHeaderComponent,
  StatusBarComponent,
  CircleProgressComponent,
  TimeComponent,
  ChipComponent,
  EmptyStateComponent,
  LinkedEntitiesComponent,
  MultilineTextWithElipsisComponent,
  UserAvatarComponent,
  DateViewComponent,
  MetadataViewComponent,
  TimeframeViewComponent,
  TimeAgoDateViewComponent,
  ProgressBarComponent,
  NewlyAddedLabelComponent,
  InfoIconComponent,
  NotFoundComponent,
  GapMarkComponent,
  InvalidLinkComponent,
  BorderedSectionComponent,
  ItemBoxComponent,
  ItemDividerComponent,
  LabelComponent,
  DueDateComponent,
  RouteNotFoundComponent,
  ItemBoxStateDirective,
  FormattedTextComponent,
  HeaderInfoTitleComponent,
  PoweredByLinkComponent,
  ExpandableGroupComponent,
} from './components';
import { CommonModule } from '@angular/common';
import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { LottieModule } from 'ngx-lottie';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { RouterModule } from '@angular/router';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { AssetsService, MutationObserverWrapper, IdGeneratorService } from './services';
import { PipesModule } from '@anecdotes/design-system/pipes';
import { ASSETS_PATH } from '@anecdotes/design-system/injection-tokens';
import { UtilsConfig } from './models';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  imports: [
    CommonModule,
    LottieModule,
    SvgIconsModule,
    TranslateModule,
    NgCircleProgressModule,
    RouterModule,
    ButtonsModule,
    NgbTooltipModule,
    DirectivesModule,
    PipesModule,
    MatExpansionModule,
  ],
  declarations: [
    SuccessAnimationComponent,
    TextComponent,
    AnecdotesFooterComponent,
    StepperHeaderComponent,
    StatusBarComponent,
    CircleProgressComponent,
    TimeComponent,
    ChipComponent,
    EmptyStateComponent,
    LinkedEntitiesComponent,
    MultilineTextWithElipsisComponent,
    UserAvatarComponent,
    DateViewComponent,
    MetadataViewComponent,
    TimeframeViewComponent,
    TimeAgoDateViewComponent,
    ProgressBarComponent,
    NewlyAddedLabelComponent,
    InfoIconComponent,
    NotFoundComponent,
    GapMarkComponent,
    ItemDividerComponent,
    InvalidLinkComponent,
    BorderedSectionComponent,
    ItemBoxComponent,
    ItemBoxStateDirective,
    LabelComponent,
    DueDateComponent,
    RouteNotFoundComponent,
    FormattedTextComponent,
    HeaderInfoTitleComponent,
    PoweredByLinkComponent,
    ExpandableGroupComponent,
  ],
  exports: [
    SuccessAnimationComponent,
    TextComponent,
    AnecdotesFooterComponent,
    StepperHeaderComponent,
    StatusBarComponent,
    CircleProgressComponent,
    TimeComponent,
    ChipComponent,
    EmptyStateComponent,
    LinkedEntitiesComponent,
    MultilineTextWithElipsisComponent,
    UserAvatarComponent,
    DateViewComponent,
    MetadataViewComponent,
    TimeframeViewComponent,
    TimeAgoDateViewComponent,
    ProgressBarComponent,
    NewlyAddedLabelComponent,
    InfoIconComponent,
    NotFoundComponent,
    GapMarkComponent,
    ItemDividerComponent,
    InvalidLinkComponent,
    BorderedSectionComponent,
    ItemBoxComponent,
    ItemBoxStateDirective,
    LabelComponent,
    DueDateComponent,
    RouteNotFoundComponent,
    FormattedTextComponent,
    HeaderInfoTitleComponent,
    PoweredByLinkComponent,
    ExpandableGroupComponent,
  ],
  providers: [
    MutationObserverWrapper,
    IdGeneratorService,
    AssetsService,
    {
      provide: ASSETS_PATH,
      useValue: 'apps/assets',
    },
  ],
})
export class UtilsModule {
  static forRoot(configFactory: (injector: Injector) => UtilsConfig): ModuleWithProviders<UtilsModule> {
    return {
      ngModule: UtilsModule,
      providers: [
        {
          provide: 'utils-config',
          useFactory: configFactory,
          deps: [Injector],
        },
      ],
    };
  }
}
